import tw, { styled } from 'twin.macro'
import { OptimizedImage } from '~/components/molecules/OptimizedImage'

export const ScreenWrapper = styled.div`
  ${tw`flex flex-col`}
`

export const FeatureImageWrapper = styled.div`
  ${tw`[height:36rem] short:[height:30rem] lg:[height:44rem] relative`}
`

export const FeatureImage = styled(OptimizedImage)`
  ${tw`bg-gold-500 dark:bg-taupe-500`}
`

export const WhyCustomersPreferSection = styled.div`
  img {
    transform: scaleX(-1);
    ${tw`[object-position:28%_50%]`}
  }
`

export const MountainHeaderImage = styled.img`
  ${tw`ml-auto pt-12 xl:pt-24`}
  ${tw`w-full md:[width:80%] lg:[width:70%] xl:[width:60%]`}
  ${tw` lg:mb-[-2rem] xl:mb-[-3rem] 2xl:mb-[-4rem]`}
`

export const InformationSection = styled.section`
  ${tw`grid grid-cols-1 xl:grid-cols-2 xl:grid-rows-[minmax(85vh, min-content)] w-full`}
`

export const InformationImageWrapper = styled.div`
  ${tw`hidden xl:block [grid-column:1_/_span_1] [grid-row:1_/_span_1] self-end h-full relative`}
`

export const InformationImage = styled(OptimizedImage)`
  ${tw`bg-gold-500 dark:bg-taupe-500`}
`

export const InlineInformationImageWrapper = styled.div`
  ${tw`xl:hidden mb-6 lg:mb-12 [height:36rem] md:[height:42rem] [width:100vw] relative`}
`

export const InformationContent = styled.div`
  ${tw`xl:[grid-column:2_/_span_1] [grid-row:1_/_span_1] justify-self-end dark:text-white md:mt-[-2rem] lg:pb-8`}

  > h2 {
    ${tw`text-3xl pb-6 lg:pb-12 w-full md:w-3/4 px-6 md:px-10 xl:px-16`}
  }

  > p {
    ${tw`text-xl px-6 md:px-10 xl:px-16`}
  }

  > p:not(:first-of-type) {
    ${tw`pt-6`}
  }

  > p:last-of-type {
    ${tw`pb-6`}
  }
`

export const AboutProfile = styled.div`
  ${tw`px-8 md:px-14 pb-12 lg:pb-20 max-w-3xl`}

  > h3 {
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    ${tw`text-4xl font-bold [line-height:3rem]`}
    ${tw`whitespace-nowrap w-min`}
    ${tw`[background-image:linear-gradient(270deg,_#FB5341_0%,_#FFC425_10%,_#473D39_33%,_#222222_100%)] dark:[background-image:linear-gradient(270deg,_#FB5341_0%,_#D9BF00_100%)]`}
  }

  > h4 {
    font-family: 'Sarabun', sans-serif;
    ${tw`uppercase font-light [letter-spacing:0.2em]`}
  }

  > p {
    ${tw`pt-6`}
  }
`

export const Strong = styled.strong`
  ${tw`underline`}
`

export const Smaller = styled.p`
  ${tw`text-sm`}
`
